<div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <h4>Preguntas</h4>
        </div>
    </div>
    <div class="row" *ngFor="let preguntaHija of subPreguntas">
        <div class="col flex-grow-0 my-auto">
            <h3 class="mb-0 pe-1 mas-chico" [style.color]="colores[obtenerId(pregunta.Tipo)]"
                [attr.item-id]="!accesoPublico ? preguntaHija.Id : null" container="body"
                ngbTooltip="{{!accesoPublico ? preguntaHija.Id : null}}">
                {{ preguntaHija.IdRelativo }}
            </h3>
        </div>
        <div class="col flex-grow-0 my-auto">
            <div class="form-check form-switch">
                <input type="checkbox" class="form-check-input"
                       [id]="'opcional-' + (accesoPublico ? preguntaHija.Id.toString() : null)"
                    [(ngModel)]="preguntaHija.Opcional" [disabled]="accesoPublico">
                <label class="form-check-label"
                       [for]="'opcional-' + (accesoPublico ? preguntaHija.Id.toString() : null)">Opcional</label>
            </div>
        </div>
        <div class="col d-flex align-items-center">
            <input type="text" class="form-control no-borders" [(ngModel)]="preguntaHija.Texto" [disabled]="accesoPublico">
        </div>
        <div class="col flex-grow-0 text-end mt-auto seleccionable" *ngIf="!accesoPublico"
            (click)="abrirEditorCondiciones(preguntaHija)">
            <span>
                <i class="fa-regular fa-list-check fa-xl"></i>
            </span>
        </div>
        <div class="col flex-grow-0 text-end my-auto" (click)="clickBorrarPregunta(preguntaHija)"
             [class.seleccionable]="borrarPreguntaCmd.puedeEjecutarse" *ngIf="!accesoPublico">
            <span><i class="fa-regular fa-trash-can fa-xl"></i></span>
        </div>
    </div>
    <div class="row" *ngIf="!accesoPublico">
        <div class="col flex-grow-0 h3 mb-0 pe-0">+</div>
        <div class="col mb-3">
            <input type="text" placeholder="Agregue una pregunta..." class="form-control no-borders"
                [(ngModel)]="textoPregunta" (keyup.enter)="agregarPreguntaCmd.ejecutar()"
                [disabled]="!agregarPreguntaCmd.puedeEjecutarse">
        </div>
    </div>

    <div class="row mt-4">
        <div class="col-12">
            <h4>Respuestas</h4>
        </div>
    </div>
    <div class="row" *ngFor="let itemHijo of items">
        <div class="col flex-grow-0 my-auto">
            <h3 class="mb-0 pe-1 mas-chico" [style.color]="colores[obtenerId(pregunta.Tipo)]"
                [attr.item-id]="!accesoPublico ? itemHijo.Id : null" container="body"
                ngbTooltip="{{!accesoPublico ? itemHijo.Id : null}}">
                {{ itemHijo.IdRelativo }}
            </h3>
        </div>
        <div class="col d-flex align-items-center">
            <input type="text" class="form-control no-borders" [(ngModel)]="itemHijo.Texto" [disabled]="accesoPublico">
        </div>
        <div class="col flex-grow-0 text-end my-auto pe-0" *ngIf="itemHijo.EsOpcionKiller">
            <h4 class="mb-0">(K)</h4>
        </div>
        <div class="col flex-grow-0 text-end mt-auto seleccionable" *ngIf="!accesoPublico"
            (click)="abrirEditorCondicionesItem(itemHijo)">
            <span>
                <i class="fa-regular fa-list-check fa-xl"></i>
            </span>
        </div>
        <div class="col flex-grow-0 text-end my-auto" [class.seleccionable]="borrarItemCmd.puedeEjecutarse"
            (click)="clickBorrarItem(itemHijo)" *ngIf="!accesoPublico">
            <span><i class="fa-regular fa-trash-can fa-xl"></i></span>
        </div>
    </div>
    <div class="row" *ngIf="!accesoPublico">
        <div class="col flex-grow-0 h3 mb-0 pe-0">+</div>
        <div class="col mb-3">
            <input type="text" placeholder="Agregue una respuesta..." class="form-control no-borders"
                [(ngModel)]="textoItem" (keyup.enter)="agregarItemCmd.ejecutar()"
                [disabled]="!agregarItemCmd.puedeEjecutarse">
        </div>
    </div>
</div>
